import { Component, OnInit } from '@angular/core'
import { DataPageOfFinancial, Financial } from '../../../../../api/models'
import { UntypedFormBuilder } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { FinancialService } from '../../../../../api/services'
import { DatePipe } from '@angular/common'
import { NgxSpinnerService } from 'ngx-spinner'
import { Dialog } from 'primeng/dialog'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { CareFinitySession } from '../../../../services/CareFinitySession'

@Component({
  selector: 'app-financial-details',
  templateUrl: './financial-details.component.html',
  styleUrls: ['./financial-details.component.css'],
})
export class FinancialDetailsComponent implements OnInit {
  Item = 'Encounter'
  insurance: Financial[]
  encounter: Financial[]
  notedetails: Financial[]
  transaction: Financial[]
  Lastpageindex: number = 1
  rows: number
  _selectedColumns: any[]
  Encounterno: any
  Billingdate: any
  RenderingProvider: any
  displaypopup: boolean = false

  displaypopupTransactions: boolean = false

  insurancecard: boolean = false
  servicepopup: boolean = false
  encounterpopup: boolean = false
  popupheader: string = ''
  dateofservice: string = ''
  proceduralcode: string = ''
  leftimage: any
  rightimage: any
  patientnote: SafeHtml
  private Inscols: any[]
  private enccols: any[]
  private notecols: any[]
  private trancols: any[]
  othercol: any[]

    public activeIndex: number = 0;
    IsViewEOBImage: boolean = false;
    IsViewInsuranceCard: boolean = false;
  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private fnservice: FinancialService,
    private activatedRoute: ActivatedRoute,
    private datePipe: DatePipe,
    private _spinnerService: NgxSpinnerService,
    protected sanitizer: DomSanitizer,
  ) {}
    ngOnInit() {

        this.IsViewEOBImage = CareFinitySession?.practiceSettings.viewEOBImage;
        this.IsViewInsuranceCard = CareFinitySession?.practiceSettings.viewInsuranceCard;


    this.activatedRoute.queryParams.subscribe((params) => {
      let data = params
      this.Encounterno = data.enc_no
      this.Billingdate = data.billing_date
      this.RenderingProvider = data.ren_provider
    })
    this.Inscols = [
      { field: 'cob', header: 'COB' },
      { field: 'payer_Name', header: 'Payer Name' },
      { field: 'payer_Address', header: 'Payer Address' },
      { field: 'policy_Number', header: 'Policy Number' },
      { field: 'group_Number', header: 'Group Number' },
      { field: 'insureds_name', header: 'Insured`s name' },
    ]
    this.enccols = [
      { field: 'dateofservice', header: 'Date of Service' },
      { field: 'serviceItem', header: 'Procedure code' },
      { field: 'charge', header: 'Charge AMT' },
      { field: 'amtpaid', header: 'Paid AMT' },
      { field: 'adjamt', header: 'Adj AMt' },
      { field: 'amtbalance', header: 'Balance' },
      { field: 'coB1', header: 'COB1 AMT' },
      { field: 'coB2', header: 'COB2 AMT' },
      { field: 'coB3', header: 'COB3 AMT' },
      { field: 'paTAmt', header: 'Pat AMT' },
    ]
    this.notecols = [
      { field: 'date', header: 'DATE' },
      { field: 'noteType', header: 'Note Type' },
      { field: 'noteTittle', header: 'Note Title' },
    ]
    this.trancols = [
      { field: 'tranDate', header: 'Transaction Date' },
      { field: 'tranType', header: 'Type' },
      { field: 'trancode', header: 'Transaction Code' },
      { field: 'tracking', header: 'Tracking' },
      { field: 'owedAmt', header: 'Owed AMT' },
      { field: 'paidAmt', header: 'Paid AMT' },
      { field: 'adjustement', header: 'Adjustment AMT' },
    ]
    this.financialList(1, 'Desc')
    this.activeIndex = 0
  }

  financialList(pageNumber: number, sortbydirection: string) {
    this.fnservice
      .financialGetInsuranceList({
        PatientId: sessionStorage.getItem('ptId'),
        emrpracticeId: localStorage.getItem('EmrPracticeId'),
        Encounterno: this.Encounterno,
        Billingdate: this.Billingdate,
        RenderingProvider: this.RenderingProvider,
      })
      .subscribe((result) => {
        this.insurance = result.insuranceSummary
        this.encounter = result.serviceList
        this.notedetails = result.encounternote
      })
  }
  backtosummary() {
    this.router.navigate(['Patient/financial/list'], {
      skipLocationChange: true,
    })
  }

  getdetails11(obj) {
    this.displaypopupTransactions = true
    // this.insurancecard = true;
    //  this.displaypopup = false;

    if (true) {
      this.encounterpopup = false
      this.servicepopup = false
      this.insurancecard = true
      this.popupheader = 'Insurance Card'

      this.fnservice
        .financialInsuranceDetail({
          PatientId: sessionStorage.getItem('ptId'),
          PracticeId: localStorage.getItem('EmrPracticeId'),
          ID: obj.insured_Id,
          policyno: obj.policy_Number,
          grpno: obj.group_Number,
        })
        .subscribe((result) => {
          this.leftimage = 'data:image/png;base64,' + result.leftInsuranceImg
          this.rightimage = 'data:image/png;base64,' + result.rightInsuranceImg
        })
    }
  }
  getdetails(obj, item) {
    this.displaypopup = true

    if (item == 'Insu') {
      this.encounterpopup = false
      this.servicepopup = false
      this.insurancecard = true
      this.popupheader = 'Insurance Card'

      this.fnservice
        .financialInsuranceDetail({
          PatientId: sessionStorage.getItem('ptId'),
          PracticeId: localStorage.getItem('EmrPracticeId'),
          ID: obj.insured_Id,
          policyno: obj.policy_Number,
          grpno: obj.group_Number,
        })
        .subscribe((result) => {
          this.leftimage = 'data:image/png;base64,' + result.leftInsuranceImg
          this.rightimage = 'data:image/png;base64,' + result.rightInsuranceImg
        })
    } else if (item == 'mess') {
      this.popupheader = 'Note'
      this.insurancecard = false
      this.encounterpopup = true
      this.servicepopup = false

      this.fnservice
        .financialEncounterNoteDetail({
          PatientId: sessionStorage.getItem('ptId'),
          PracticeId: localStorage.getItem('EmrPracticeId'),
          ID: obj.noteid,
          Type: obj.noteType,
        })
        .subscribe((result) => {
          this.patientnote = this.sanitizer.bypassSecurityTrustHtml(
            result.noteMessage,
          )
        })
    } else if (item == 'encdetails') {
      this.popupheader = 'Transactions Tied To Charge'
      this.dateofservice = obj.dateofservice
      this.proceduralcode = obj.serviceItem
      this.insurancecard = false
      this.encounterpopup = false
      this.servicepopup = true
      this.fnservice
        .financialTransactionDetail({
          PatientId: sessionStorage.getItem('ptId'),
          PracticeId: localStorage.getItem('EmrPracticeId'),
          ServiceItem: obj.serviceItem,
          Dateofservice: obj.dateofservice,
          charge_id: obj.charge_id,
          Encounterno: this.Encounterno,
        })
        .subscribe((result) => {
          this.transaction = result.transactionList
        })
    } else if (item == 'TransactionImg') {
      this.displaypopupTransactions = true
      this.encounterpopup = false
      this.servicepopup = true
      this.insurancecard = false
      this.popupheader = 'Transactions :: Image Details' 
        console.log('Transactions :: Image Details')

        console.log(obj)
      //this.fnservice
      //  .financialInsuranceDetail({
      //    PatientId: sessionStorage.getItem('ptId'),
      //    PracticeId: localStorage.getItem('EmrPracticeId'),
      //    ID: obj.insured_Id,
      //    policyno: obj.policy_Number,
      //    grpno: obj.group_Number,
      //  })
      //  .subscribe((result) => {
      //    this.leftimage = 'data:image/png;base64,' + result.leftInsuranceImg
      //    this.rightimage = 'data:image/png;base64,' + result.rightInsuranceImg
        //  })


        this.fnservice
            .financialInsuranceImageDataDetails({           
            ID: obj.insured_Id,          
            tranId: obj.group_Number,
            PatientId: sessionStorage.getItem('ptId'),
            PracticeId: localStorage.getItem('EmrPracticeId')
          }).subscribe((result) => {
              // this.leftimage = 'data:image/png;base64,'+result.transactionImg
              this.leftimage = result.transactionImg;

            })
    }
  }

  calculateGroupTotal(obj) {
    switch (obj) {
      case 'tc':
        return this.encounter[0].total_Charge
      case 'tap':
        return this.encounter[0].total_Amtpaid
      case 'tadam':
        return this.encounter[0].total_adjamt
      case 'tb':
        return this.encounter[0].total_balance
      case 'tcob1':
        return this.encounter[0].total_COB1
      case 'tcob2':
        return this.encounter[0].total_COB2
      case 'tcob3':
        return this.encounter[0].total_COB3
      case 'tpat':
        return this.encounter[0].total_Pat

      default:
        return '0.00'
    }
  }

  setItem(item: any) {
    alert('hhh')
  }
}
